/** Sample values for admin email template preview (matches backend test defaults). */
export const EMAIL_PREVIEW_SAMPLES: Record<string, string> = {
  otp: '123456',
  expiry_minutes: '5',
  name: 'Alex',
  twin_name: 'Career Twin',
  other_twin_name: 'Acme Recruiter Twin',
  match_percentage: '82',
  credits_added: '25',
  credits_balance: '35',
  package_name: 'Basic',
};

export function buildPreviewVariables(variableNames: string[]): Record<string, string> {
  const out: Record<string, string> = {};
  for (const name of variableNames) {
    out[name] = EMAIL_PREVIEW_SAMPLES[name] ?? `sample_${name}`;
  }
  return out;
}

/** Renders `{{ variable }}` placeholders (Jinja2-style subset used in our templates). */
export function renderEmailTemplateString(
  template: string,
  variables: Record<string, string | number>
): string {
  return template.replace(/\{\{\s*([\w.]+)\s*\}\}/g, (_, key: string) => {
    const value = variables[key];
    return value !== undefined && value !== null ? String(value) : `{{ ${key} }}`;
  });
}

export function parsePreviewVariablesText(text: string): Record<string, string> {
  const out: Record<string, string> = {};
  text.split('\n').forEach((line) => {
    const trimmed = line.trim();
    if (!trimmed) return;
    const eq = trimmed.indexOf('=');
    if (eq === -1) return;
    const key = trimmed.slice(0, eq).trim();
    const value = trimmed.slice(eq + 1).trim();
    if (key) out[key] = value;
  });
  return out;
}

export function previewVariablesToText(variables: Record<string, string>): string {
  return Object.entries(variables)
    .map(([k, v]) => `${k}=${v}`)
    .join('\n');
}
